module.exports = __webpack_public_path__ + "img/watch_tab_small.f8e413e8.webp";